/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  MdClose,
  MdEmail,
  MdOutlineArrowBack,
  MdOutlineCreate,
  MdOutlineFilterAlt,
  MdOutlineMail,
  MdOutlineSupportAgent,
  MdOutlineWhatsapp,
  MdPhone,
} from 'react-icons/md';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { BsGraphUpArrow } from 'react-icons/bs';
import add from 'date-fns/add';
import sub from 'date-fns/sub';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import {
  searchFlightsApi,
  emailFlightOptions,
  getClassAvailabilityFareForRoundtrip,
  getPassThroughInfo,
  getFareInclusion,
  validateIntlNormalRtFlightPriceApi,
} from '../../api/flightApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import SortOptions from '../one-way/SortOptions';
import {
  formatDate,
  getGroupedFlightOptions,
  isAfterDate,
  isSameDate,
  isBeforeDate,
  formatCurrency,
  hideHeaderMenu,
  showHeaderMenu,
  isMobileWidth,
  formatTimeString,
  hideUpdatesOptions,
  showUpdatesOptions,
  getNewDate,
  isEmpty,
  hideHeaderFooterInMobile,
  showHeaderFooterInMobile,
} from '../../shared/helper-utils/appUtils';
import ModifySearch from '../flights/ModifySearch';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import ResultsFooter from '../one-way/ResultsFooter';
import {
  getObjectFromLS,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import {
  API_DATE_FORMAT,
  DATE_MONTH_DAY_FORMAT,
  NAVIGATION_ROUTES,
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  TODAY_DATE,
  DATE_MONTH_VIEW_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
} from '../../shared/constants/Constants';
import AppModal from '../../shared/components/app-modal/AppModal';
import NoSearchResults from '../one-way/NoSearchResults';
import CountdownTimer from '../../shared/components/countdown-timer/CountdownTimer';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import RoundTripFilters from './RoundTripFilters';
import { debounce } from '../../api/apiUtils';
import OneWayResultCard from '../one-way/OneWayResultCard';
import EmailContent from '../one-way/EmailContent';
import { getUserDetails } from '../../api/profileApi';
import RoundTripWhatsappModal from './RoundTripWhatsappModal';
import AppPreviewLoader from '../../shared/components/app-preview-loader/AppPreviewLoader';
import AppButton from '../../shared/components/app-button/AppButton';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';
import FlightSelectionViewToggle from './FlightSelectionViewToggle';

const SEARCH_AIRLINES = ['SG', '6E', 'I5', 'QP', 'AI', 'S9', '9I'];

const CORPORATE_SEARCH_AIRLINES = ['AI'];
const GDS_SPECIAL_ROUNDTRIP = [];
const GDS_CORPORATE_SPECIAL_ROUNDTRIP = [];
const LCC_SPECIAL_ROUNDTRIP = [];
const BRANDED_AIRLINES = ['AI'];
const SERIES_AIRLINES = ['All'];

const DEFENCE_FARE_AIRLINES = ['6ED', 'SGD', 'QPD', 'I5D', 'IXD', 'AID'];

function FlightRoundTripSearchResultsPagespl() {
  const { appConfig } = useAppContext();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const FIFTEEN_MIN_IN_MILLI_SECS = 11 * 60 * 1000;
  const NOW_IN_MILLI_SECS = getNewDate(TODAY_DATE).getTime();
  const [fifteenMinFromNowInMilli, setFifteenMinFromNowInMilli] = useState(
    NOW_IN_MILLI_SECS + FIFTEEN_MIN_IN_MILLI_SECS,
  );
  const navigate = useNavigate();
  const roundTripSectorsRef = useRef([]);
  const [alert, setAlert] = useState(undefined);
  const [selectedSector, setSelectedSector] = useState('');
  const [searchParams] = useSearchParams();
  const bookingResponseRef = useRef(null);
  const onwardAllSearchResultsRef = useRef([]);
  const returnAllSearchResultsRef = useRef([]);
  const [hasSearchResults, setHasSearchResults] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [onwardSearchResults, setOnwardSearchResults] = useState([]);
  const [returnSearchResults, setReturnSearchResults] = useState([]);
  const [searchRequest, setSearchRequest] = useState(undefined);
  const [openFilters, setOpenFilters] = useState(false);
  const [minFlightFare, setMinFlightFare] = useState(0);
  const [maxFlightFare, setMaxFlightFare] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: minFlightFare,
    selectedMaxPrice: maxFlightFare,
    selectedOnwardStops: [],
    selectedReturnStops: [],
    selectedOnwardDepartureTimes: [],
    selectedReturnDepartureTimes: [],
    selectedOnwardArraivalTimes: [],
    selectedReturnArraivalTimes: [],
    selectedOnwardCarriers: [],
    selectedReturnCarriers: [],
    selectedFareTypes: [],
    selectedRefundStatus: [],
    selectedFlightNumber: '',
    selectedEquipment: '',
    isOnwardSameDayArraival: false,
    isReturnSameDayArraival: false,
  });
  const [isAmPmFormatSelected, setIsAmPmFormatSelected] = useState(false);
  const [selectedOnwardFare, setSelectedOnwardFare] = useState(undefined);
  const [selectedReturnFare, setSelectedReturnFare] = useState(undefined);
  const [selectedOnwardFlight, setSelectedOnWardFlight] = useState(undefined);
  const [selectedReturnFlight, setSelectedReturnFlight] = useState(undefined);
  const [showPriceChangedModal, setShowPriceChangedModal] = useState(false);
  const [progressWidth, setProgressWidth] = useState(0);
  const showProgressRef = useRef(true);
  const flightCarriesRef = useRef([]);
  const flightFaresRef = useRef([]);
  const fareInclusionRef = useRef([]);
  const agentid = getUserAgentId();
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false);
  const [showInvoiceFare, setShowInvoiceFare] = useState(false);
  const [selectedOnwardForEmail, setSelectedOnwardForEmail] = useState([]);
  const [selectedReturnForEmail, setSelectedReturnForEmail] = useState([]);
  const [abortController, setAbortController] = useState(new AbortController());
  const [page, setPage] = useState(0);
  const [shownOnwardResults, setShownOnwardResults] = useState([]);
  const [shownReturnResults, setShownReturnResults] = useState([]);
  const onwardSortOrderRef = useRef('asc');
  const onwardSortParamRef = useRef('price');
  const returnSortOrderRef = useRef('asc');
  const returnSortParamRef = useRef('price');
  const [currencyOption, setCurrencyOption] = useState(appConfig?.appCurrency);
  const [conversionRate, setConversionRate] = useState(1);
  const [oldAmount, setOldAmount] = useState(0);
  const [newRepricedAmount, setnewRepricedAmount] = useState(0);
  const [isModifySearch, setIsModifySearch] = useState(false);
  const [selectedClassInfo, setselectedClassInfo] = useState({
    onwardFlight: undefined,
    returnFlight: undefined,
    selectedOnwardClassFare: undefined,
    selectedReturnClassFare: undefined,
    cacheKey: '',
    cacheKey_return: '',
    selectedOnwardList: [],
    selectedReturnList: [],
  });
  const passThroughResponseRef = useRef(null);
  const [OpenAlerDialog, setOpenAlerDialog] = useState(false);
  const alertMessageRef = useRef('');
  const flightModifyRef = useRef(null);
  const [flightModifyDivHeight, setFlightModifyDivHeight] = useState(0);
  const sectorInfoRef = useRef('');
  const onwardFlightCarriesRef = useRef([]);
  const returnFlightCarriesRef = useRef([]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        if (entry.target === flightModifyRef.current) {
          setFlightModifyDivHeight(entry.contentRect.height);
        }
      }
    });

    if (flightModifyRef.current) {
      resizeObserver.observe(flightModifyRef.current);
    }

    return () => {
      if (flightModifyRef.current) {
        resizeObserver.unobserve(flightModifyRef.current);
      }
    };
  }, [searchRequest]);
  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);
  useEffect(() => {
    hideUpdatesOptions();
    return () => showUpdatesOptions();
  });

  const groupByFlightCarrierAndFlightNumber = (flightOptions) => {
    let groupedFlightOptions = getGroupedFlightOptions(flightOptions);
    groupedFlightOptions = Object.values(groupedFlightOptions);
    groupedFlightOptions.sort(
      (flightOption1, flightOption2) =>
        flightOption1.recommendedflight[0].flightfare[0].totalfq -
        flightOption2.recommendedflight[0].flightfare[0].totalfq,
    );

    return groupedFlightOptions;
  };

  const appendOnwardResults = (pageNumber, results) => {
    const startindex = pageNumber * 20;
    const endIndex = startindex + 20;
    let newResults;
    if (startindex > results.length) {
      return;
    }
    if (endIndex > results.length) {
      newResults = results.slice(0, results.length);
    } else {
      newResults = results.slice(0, endIndex);
    }
    setShownOnwardResults(newResults);
  };
  const appendReturnResults = (pageNumber, results) => {
    const startindex = pageNumber * 20;
    const endIndex = startindex + 20;
    let newResults;
    if (startindex > results.length) {
      return;
    }
    if (endIndex > results.length) {
      newResults = results.slice(0, results.length);
    } else {
      newResults = results.slice(0, endIndex);
    }
    setShownReturnResults(newResults);
  };

  useEffect(() => {
    appendOnwardResults(page, onwardSearchResults);
    appendReturnResults(page, returnSearchResults);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight - 100;
      // const scrollThreshold = 100;
      if (scrollY >= pageHeight) {
        setPage((prev) => prev + 1);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSort = (param, order, isOnward, results) => {
    if (isOnward) {
      onwardSortParamRef.current = param;
      onwardSortOrderRef.current = order;
    } else {
      returnSortParamRef.current = param;
      returnSortOrderRef.current = order;
    }
    let list;
    if (results === undefined) {
      list = isOnward ? [...onwardSearchResults] : [...returnSearchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].flightfare[0].totalfq -
            flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].totaljourneyduration -
            flightOption1.recommendedflight[0].totaljourneyduration,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].totaljourneyduration -
            flightOption2.recommendedflight[0].totaljourneyduration,
        );
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    if (isOnward) {
      setOnwardSearchResults(list);
      appendOnwardResults(0, list);
      appendReturnResults(0, returnSearchResults);
    } else {
      setReturnSearchResults(list);
      appendReturnResults(0, list);
      appendOnwardResults(0, onwardSearchResults);
    }
  };
  const handleSort1 = (param, order, isOnward, results) => {
    if (isOnward) {
      onwardSortParamRef.current = param;
      onwardSortOrderRef.current = order;
    } else {
      returnSortParamRef.current = param;
      returnSortOrderRef.current = order;
    }
    let list;
    if (results === undefined) {
      list = isOnward ? [...onwardSearchResults] : [...returnSearchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].flightfare[0].totalfq -
            flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].totaljourneyduration -
            flightOption1.recommendedflight[0].totaljourneyduration,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].totaljourneyduration -
            flightOption2.recommendedflight[0].totaljourneyduration,
        );
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    if (isOnward) {
      appendOnwardResults(0, list);
      return list;
    }
    appendReturnResults(0, list);
    return list;
  };

  const handleApplyFilter = debounce((filters) => {
    setOpenFilters(false);
    setSelectedFilters(filters);
    let onWardFilteredSearchResults = JSON.parse(
      JSON.stringify(onwardAllSearchResultsRef.current),
    );
    if (filters.selectedOnwardCarriers.length > 0) {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) => {
          let legs = resultRow.recommendedflight[0].flightlegs;
          legs = Array.isArray(legs) ? legs : [legs];
          return legs.some(
            (x) =>
              filters.selectedOnwardCarriers.indexOf(x.validatingcarriername) >
              -1,
          );
        },
      );
    }
    if (filters.selectedOnwardStops.length > 0) {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) =>
          filters.selectedOnwardStops.indexOf(
            (resultRow.recommendedflight[0].flightlegs.length - 1).toString(),
          ) > -1,
      );
    }
    if (filters.selectedOnwardDepartureTimes.length > 0) {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) => {
          const depTime = Number(
            resultRow.recommendedflight[0].flightlegs[0].deptime,
          );
          return filters.selectedOnwardDepartureTimes.some((timeRange) => {
            const timeRangeArr = timeRange.split('-');
            return (
              depTime >= Number(timeRangeArr[0]) &&
              depTime <= Number(timeRangeArr[1])
            );
          });
        },
      );
    }
    if (filters.selectedOnwardArraivalTimes.length > 0) {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) => {
          const depTime = Number(
            resultRow.recommendedflight[0].flightlegs[
              resultRow.recommendedflight[0].flightlegs.length - 1
            ].arrtime,
          );
          return filters.selectedOnwardArraivalTimes.some((timeRange) => {
            const timeRangeArr = timeRange.split('-');
            return (
              depTime >= Number(timeRangeArr[0]) &&
              depTime <= Number(timeRangeArr[1])
            );
          });
        },
      );
    }
    if (filters.selectedMinPrice) {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq >=
          filters.selectedMinPrice,
      );
    }
    if (filters.selectedMaxPrice) {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq <=
          filters.selectedMaxPrice,
      );
    }
    if (filters.selectedRefundStatus.length > 0) {
      onWardFilteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedRefundStatus.indexOf(x.refundableinfo) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) => {
          const fares = resultRow.recommendedflight[0].flightfare;
          return fares.length > 0;
        },
      );
    }
    if (filters.selectedFareTypes.length > 0) {
      onWardFilteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedFareTypes.indexOf(x.faretype) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) => {
          const fares = resultRow.recommendedflight[0].flightfare;
          return fares.length > 0;
        },
      );
    }
    if (filters.selectedFlightNumber !== '') {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) => {
          const carrier = filters.selectedFlightNumber
            .toLowerCase()
            .split('-')[0]
            .substring(0, 2);
          const fltNum = filters.selectedFlightNumber.split('-')[1];
          let legs = resultRow.recommendedflight[0].flightlegs;
          legs = Array.isArray(legs) ? legs : [legs];
          if (fltNum) {
            return legs.some(
              (x) =>
                x.carrier.toLowerCase().indexOf(carrier) > -1 &&
                x.flightnumber.indexOf(fltNum) > -1,
            );
          }
          return legs.some(
            (x) => x.carrier.toLowerCase().indexOf(carrier) > -1,
          );
        },
      );
    }
    if (filters.selectedEquipment !== '') {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) => {
          let legs = resultRow.recommendedflight[0].flightlegs;
          legs = Array.isArray(legs) ? legs : [legs];
          return legs.some(
            (x) =>
              x.equipment
                ?.toLowerCase()
                .indexOf(filters.selectedEquipment?.toLowerCase()) > -1,
          );
        },
      );
    }
    if (filters.isOnwardSameDayArraival === true) {
      onWardFilteredSearchResults = onWardFilteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightlegs[0].depdate ===
          resultRow.recommendedflight[0].flightlegs[
            resultRow.recommendedflight[0].flightlegs.length - 1
          ].arrdate,
      );
    }

    onWardFilteredSearchResults = handleSort1(
      onwardSortParamRef.current,
      onwardSortOrderRef.current,
      true,
      onWardFilteredSearchResults,
    );
    setOnwardSearchResults(onWardFilteredSearchResults);
    let returnFilteredSearchResults = JSON.parse(
      JSON.stringify(returnAllSearchResultsRef.current),
    );
    if (filters.selectedReturnCarriers.length > 0) {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) => {
          let legs = resultRow.recommendedflight[0].flightlegs;
          legs = Array.isArray(legs) ? legs : [legs];
          return legs.some(
            (x) =>
              filters.selectedReturnCarriers.indexOf(x.validatingcarriername) >
              -1,
          );
        },
      );
    }
    if (filters.selectedReturnStops.length > 0) {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) =>
          filters.selectedReturnStops.indexOf(
            (resultRow.recommendedflight[0].flightlegs.length - 1).toString(),
          ) > -1,
      );
    }
    if (filters.selectedReturnDepartureTimes.length > 0) {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) => {
          const depTime = Number(
            resultRow.recommendedflight[0].flightlegs[0].deptime,
          );
          return filters.selectedReturnDepartureTimes.some((timeRange) => {
            const timeRangeArr = timeRange.split('-');
            return (
              depTime >= Number(timeRangeArr[0]) &&
              depTime <= Number(timeRangeArr[1])
            );
          });
        },
      );
    }
    if (filters.selectedReturnArraivalTimes.length > 0) {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) => {
          const depTime = Number(
            resultRow.recommendedflight[0].flightlegs[
              resultRow.recommendedflight[0].flightlegs.length - 1
            ].arrtime,
          );
          return filters.selectedReturnArraivalTimes.some((timeRange) => {
            const timeRangeArr = timeRange.split('-');
            return (
              depTime >= Number(timeRangeArr[0]) &&
              depTime <= Number(timeRangeArr[1])
            );
          });
        },
      );
    }
    if (filters.selectedMinPrice) {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq >=
          filters.selectedMinPrice,
      );
    }
    if (filters.selectedMaxPrice) {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq <=
          filters.selectedMaxPrice,
      );
    }
    if (filters.selectedRefundStatus.length > 0) {
      returnFilteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedRefundStatus.indexOf(x.refundableinfo) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) => {
          const fares = resultRow.recommendedflight[0].flightfare;
          return fares.length > 0;
        },
      );
    }
    if (filters.selectedFareTypes.length > 0) {
      returnFilteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedFareTypes.indexOf(x.faretype) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) => {
          const fares = resultRow.recommendedflight[0].flightfare;
          return fares.length > 0;
        },
      );
    }
    if (filters.selectedFlightNumber !== '') {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) => {
          const carrier = filters.selectedFlightNumber
            .toLowerCase()
            .split('-')[0]
            .substring(0, 2);
          const fltNum = filters.selectedFlightNumber.split('-')[1];
          let legs = resultRow.recommendedflight[0].flightlegs;
          legs = Array.isArray(legs) ? legs : [legs];
          if (fltNum) {
            return legs.some(
              (x) =>
                x.carrier.toLowerCase().indexOf(carrier) > -1 &&
                x.flightnumber.indexOf(fltNum) > -1,
            );
          }
          return legs.some(
            (x) => x.carrier.toLowerCase().indexOf(carrier) > -1,
          );
        },
      );
    }
    if (filters.selectedEquipment !== '') {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) => {
          let legs = resultRow.recommendedflight[0].flightlegs;
          legs = Array.isArray(legs) ? legs : [legs];
          return legs.some(
            (x) =>
              x.equipment
                ?.toLowerCase()
                .indexOf(filters.selectedEquipment?.toLowerCase()) > -1,
          );
        },
      );
    }
    if (filters.isReturnSameDayArraival === true) {
      returnFilteredSearchResults = returnFilteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightlegs[0].depdate ===
          resultRow.recommendedflight[0].flightlegs[
            resultRow.recommendedflight[0].flightlegs.length - 1
          ].arrdate,
      );
    }

    returnFilteredSearchResults = handleSort1(
      returnSortParamRef.current,
      returnSortOrderRef.current,
      false,
      returnFilteredSearchResults,
    );
    setReturnSearchResults(returnFilteredSearchResults);
  }, 300);

  useEffect(() => {
    handleApplyFilter(selectedFilters);
  }, [onwardAllSearchResultsRef.current, returnAllSearchResultsRef.current]);

  const updateFlightsState = (response) => {
    if (
      response.flightjourneys &&
      Array.isArray(response.flightjourneys) &&
      response.flightjourneys.length > 0
    ) {
      const onwardJourneyFlights = Array.isArray(
        response.flightjourneys[0].flightoptions,
      )
        ? response.flightjourneys[0].flightoptions
        : [response.flightjourneys[0].flightoptions];
      onwardJourneyFlights?.forEach((ele) => {
        let legs = ele?.recommendedflight[0]?.flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        const { validatingcarriername, validatingcarrier } = legs[0];
        if (!isEmpty(validatingcarriername) && !isEmpty(validatingcarrier)) {
          if (
            !onwardFlightCarriesRef.current.some(
              (x) => x.validatingcarriername === validatingcarriername,
            )
          ) {
            onwardFlightCarriesRef.current.push({
              validatingcarriername,
              validatingcarrier,
            });
          }
          onwardFlightCarriesRef.current.sort((option1, option2) =>
            option1.validatingcarriername.localeCompare(
              option2.validatingcarriername,
            ),
          );
        }
      });
      onwardJourneyFlights?.forEach((ele) => {
        let fares = ele?.recommendedflight[0]?.flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const { faretype } = fares[0];
        if (!isEmpty(faretype)) {
          if (
            !flightFaresRef.current.some(
              (x) => x.toLowerCase() === faretype.toLowerCase(),
            )
          ) {
            flightFaresRef.current.push(faretype);
          }
          flightFaresRef.current.sort((option1, option2) =>
            option1.localeCompare(option2),
          );
        }
      });
      const returnJourneyFlights =
        response.flightjourneys?.length > 1
          ? Array.isArray(response.flightjourneys[1].flightoptions)
            ? response.flightjourneys[1].flightoptions
            : [response.flightjourneys[1].flightoptions]
          : [];
      returnJourneyFlights?.forEach((ele) => {
        let legs = ele?.recommendedflight[0]?.flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        const { validatingcarriername, validatingcarrier } = legs[0];
        if (!isEmpty(validatingcarriername) && !isEmpty(validatingcarrier)) {
          if (
            !returnFlightCarriesRef.current.some(
              (x) => x.validatingcarriername === validatingcarriername,
            )
          ) {
            returnFlightCarriesRef.current.push({
              validatingcarriername,
              validatingcarrier,
            });
          }
          returnFlightCarriesRef.current.sort((option1, option2) =>
            option1.validatingcarriername.localeCompare(
              option2.validatingcarriername,
            ),
          );
        }
      });
      returnJourneyFlights?.forEach((ele) => {
        let fares = ele?.recommendedflight[0]?.flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const { faretype } = fares[0];
        if (!isEmpty(faretype)) {
          if (
            !flightFaresRef.current.some(
              (x) => x.toLowerCase() === faretype.toLowerCase(),
            )
          ) {
            flightFaresRef.current.push(faretype);
          }
          flightFaresRef.current.sort((option1, option2) =>
            option1.localeCompare(option2),
          );
        }
      });
      onwardJourneyFlights.forEach((fo) => {
        let fares = fo.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const equipmentList = [];
          const operatedByList = [];
          const handBagWeightList = [];
          const handBagWeightUnitList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            bagList.push(leg.bagweight);
            weighlist.push(leg.bagunit);
            equipmentList.push(isEmpty(leg.equipment) ? '' : leg.equipment);
            operatedByList.push(isEmpty(leg.operatedby) ? '' : leg.operatedby);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
            handBagWeightList.push(leg.cabinBagweight);
            handBagWeightUnitList.push(leg.cabinBagunit);
          });
          let supplierName = fo.recommendedflight[0].supplier;
          if (isEmpty(supplierName)) {
            const isAmadeus = fo.recommendedflight[0].nextracustomstr
              .split(',')
              .some((word) => word.includes('AMADEUS'));
            if (isAmadeus) {
              supplierName = 'amadeus';
            }
          }
          fare.supplierName = supplierName;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.ismorefaresavailable =
            fo.recommendedflight[0].ismorefaresavailable;
          fare.isminifarerulesrequired =
            fo.recommendedflight[0].isminifarerulesrequired;
          fare.flightCarrier = carrierList;
          fare.numseatsavailable = seatsList;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
          fare.flightBagWeight = bagList;
          fare.flightBagUnit = weighlist;
          fare.bookingClass = bookingClassList;
          fare.airFreeText = airFreeTextList;
          fare.cabinBagweight = handBagWeightList;
          fare.cabinBagunit = handBagWeightUnitList;
        });
      });

      const onwardAllFlights = [
        ...onwardJourneyFlights,
        ...onwardAllSearchResultsRef.current,
      ];

      const osr = groupByFlightCarrierAndFlightNumber(onwardAllFlights);
      if (osr && osr.length > 0) {
        const onwardUpdatedGroupedOptions = [...osr];
        onwardUpdatedGroupedOptions.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
        onwardAllSearchResultsRef.current = JSON.parse(
          JSON.stringify(onwardUpdatedGroupedOptions),
        );
        setOnwardSearchResults(onwardUpdatedGroupedOptions);
      }
      returnJourneyFlights.forEach((fo) => {
        let fares = fo.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const equipmentList = [];
          const operatedByList = [];
          const returnCabinWeightList = [];
          const returnCabinUnitList = [];
          const handBagWeightList = [];
          const handBagWeightUnitList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            bagList.push(leg.bagweight);
            weighlist.push(leg.bagunit);
            equipmentList.push(isEmpty(leg.equipment) ? '' : leg.equipment);
            operatedByList.push(isEmpty(leg.operatedby) ? '' : leg.operatedby);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
            returnCabinWeightList.push(leg.cabinBagweight);
            returnCabinUnitList.push(leg.cabinBagunit);
            handBagWeightList.push(leg.cabinBagweight);
            handBagWeightUnitList.push(leg.cabinBagunit);
          });
          let supplierName = fo.recommendedflight[0].supplier;
          if (isEmpty(supplierName)) {
            const isAmadeus = fo.recommendedflight[0].nextracustomstr
              .split(',')
              .some((word) => word.includes('AMADEUS'));
            if (isAmadeus) {
              supplierName = 'amadeus';
            }
          }
          fare.supplierName = supplierName;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.ismorefaresavailable =
            fo.recommendedflight[0].ismorefaresavailable;
          fare.isminifarerulesrequired =
            fo.recommendedflight[0].isminifarerulesrequired;
          fare.flightCarrier = carrierList;
          fare.numseatsavailable = seatsList;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
          fare.flightBagWeight = bagList;
          fare.flightBagUnit = weighlist;
          fare.bookingClass = bookingClassList;
          fare.airFreeText = airFreeTextList;
          fare.returnCabinBagweight = returnCabinWeightList;
          fare.returnCabinBagunit = returnCabinUnitList;
          fare.cabinBagweight = handBagWeightList;
          fare.cabinBagunit = handBagWeightUnitList;
        });
      });
      const returnAllFlights = [
        ...returnJourneyFlights,
        ...returnAllSearchResultsRef.current,
      ];
      const rsr = groupByFlightCarrierAndFlightNumber(returnAllFlights);
      if (rsr && rsr.length > 0) {
        const returnUpdatedGroupedOptions = [...rsr];
        returnUpdatedGroupedOptions.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
        returnAllSearchResultsRef.current = JSON.parse(
          JSON.stringify(returnUpdatedGroupedOptions),
        );
        setReturnSearchResults(returnUpdatedGroupedOptions);
      }
      let minFare = minFlightFare;
      let maxFare = maxFlightFare;
      const totalFares = [];
      onwardAllSearchResultsRef.current.forEach((option) => {
        const fares = option.recommendedflight[0].flightfare;
        totalFares.push(...fares);
      });
      returnAllSearchResultsRef.current.forEach((option) => {
        const fares = option.recommendedflight[0].flightfare;
        totalFares.push(...fares);
      });
      totalFares.sort(
        (flightOption1, flightOption2) =>
          flightOption1.totalfq - flightOption2.totalfq,
      );
      minFare = totalFares[0].totalfq;
      maxFare = totalFares[totalFares.length - 1].totalfq;
      setMinFlightFare(minFare);
      setMaxFlightFare(maxFare);
      setHasSearchResults(true);
    }
  };
  const sendParallelRequests = async (mergedSearchObj, controller) => {
    if (mergedSearchObj.searchtype === 'normal') {
      let current = 1;
      let normalAirlines = [];
      let corporateAirlines = [];
      let gdsspecialroundtripAirlines = [];
      let gdscorporatespecialroundtripAirlines = [];
      let lccspecialroundtripAirlines = [];
      let seriesAirlines = [];
      let brandedAirlines = [];
      let prefCarrierExtraCall = [];
      let isIntl = false;
      if (
        mergedSearchObj.originLocation.split(',').pop().trim().toLowerCase() !==
          'india' ||
        mergedSearchObj.destinationLocation
          .split(',')
          .pop()
          .trim()
          .toLowerCase() !== 'india'
      ) {
        isIntl = true;
      }
      if (mergedSearchObj.prefcarrier === 'All') {
        if (isIntl) {
          normalAirlines = ['All'];
          corporateAirlines = [...CORPORATE_SEARCH_AIRLINES];
          seriesAirlines = ['All'];
          gdsspecialroundtripAirlines = [...GDS_SPECIAL_ROUNDTRIP];
          gdscorporatespecialroundtripAirlines = [
            ...GDS_CORPORATE_SPECIAL_ROUNDTRIP,
          ];
          lccspecialroundtripAirlines = [...LCC_SPECIAL_ROUNDTRIP];
          brandedAirlines = ['All'];
        } else {
          normalAirlines = [...SEARCH_AIRLINES];
          corporateAirlines = [...CORPORATE_SEARCH_AIRLINES];
          seriesAirlines = ['All'];
          gdsspecialroundtripAirlines = [...GDS_SPECIAL_ROUNDTRIP];
          gdscorporatespecialroundtripAirlines = [
            ...GDS_CORPORATE_SPECIAL_ROUNDTRIP,
          ];
          lccspecialroundtripAirlines = [...LCC_SPECIAL_ROUNDTRIP];
          brandedAirlines = [...BRANDED_AIRLINES];
        }
      } else {
        const normalAirLineList = mergedSearchObj.prefcarrier.split(',');
        const corporateList = normalAirLineList.filter((airline) =>
          CORPORATE_SEARCH_AIRLINES.includes(airline),
        );
        const gdsspecialroundtriplist = normalAirLineList.filter((airline) =>
          GDS_SPECIAL_ROUNDTRIP.includes(airline),
        );
        const gdscorporatespecialroundtriplist = normalAirLineList.filter(
          (airline) => GDS_CORPORATE_SPECIAL_ROUNDTRIP.includes(airline),
        );
        const lccspecialroundtriplist = normalAirLineList.filter((airline) =>
          LCC_SPECIAL_ROUNDTRIP.includes(airline),
        );
        const brandedList = normalAirLineList.filter((airline) =>
          BRANDED_AIRLINES.includes(airline),
        );

        normalAirlines = normalAirLineList;
        corporateAirlines = corporateList;
        gdsspecialroundtripAirlines = gdsspecialroundtriplist;
        gdscorporatespecialroundtripAirlines = gdscorporatespecialroundtriplist;
        lccspecialroundtripAirlines = lccspecialroundtriplist;
        brandedAirlines = brandedList;
        if (mergedSearchObj.prefcarrier !== '6E') {
          prefCarrierExtraCall = ['6E'];
        }
      }
      const airlinesLength =
        normalAirlines.length +
        corporateAirlines.length +
        gdsspecialroundtripAirlines.length +
        gdscorporatespecialroundtripAirlines.length +
        lccspecialroundtripAirlines.length +
        seriesAirlines.length +
        brandedAirlines.length +
        prefCarrierExtraCall.length;
      normalAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'normal';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
      if (corporateAirlines.length > 0) {
        corporateAirlines.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'corporateonly';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (current === airlinesLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlinesLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
      }
      if (gdsspecialroundtripAirlines.length > 0) {
        gdsspecialroundtripAirlines.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'gdsspecialroundtrip';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (current === airlinesLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlinesLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
      }
      if (gdscorporatespecialroundtripAirlines.length > 0) {
        gdscorporatespecialroundtripAirlines.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'gdscorporatespecialroundtrip';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (current === airlinesLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlinesLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
      }
      if (lccspecialroundtripAirlines.length > 0) {
        lccspecialroundtripAirlines.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'lccspecialroundtrip';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (current === airlinesLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlinesLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
      }
      if (seriesAirlines.length > 0) {
        seriesAirlines.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'seriesfares';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (current === airlinesLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlinesLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
      }
      if (brandedAirlines.length > 0) {
        brandedAirlines.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'branded';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (current === airlinesLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlinesLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
      }
      if (prefCarrierExtraCall.length > 0) {
        prefCarrierExtraCall.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'normal';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (current === airlinesLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlinesLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
      }
    } else if (mergedSearchObj.searchtype === 'seriesfares') {
      let seriesAirlines = [];
      let current = 1;
      seriesAirlines = ['All'];
      seriesAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'seriesfares';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === seriesAirlines.length) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / seriesAirlines.length);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    } else if (mergedSearchObj.searchtype === 'defenceonly') {
      let current = 1;
      const normalAirlines = [...DEFENCE_FARE_AIRLINES];
      const airlinesLength = normalAirlines.length;
      normalAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'defenceonly';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    } else if (mergedSearchObj.searchtype === 'normalrt') {
      const normalRtAirlines = ['All', 'gws', '6E', 'GW2'];
      let current = 1;
      normalRtAirlines.forEach(async (airline) => {
        const request = { ...mergedSearchObj, prefcarrier: airline };
        try {
          const response = await searchFlightsApi(request, controller);
          if (current === normalRtAirlines.length) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / normalRtAirlines.length);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    } else {
      let current = 1;
      const SPECIAL_AIRLINES = ['6E', 'SG', 'UK', 'I5', 'QP'];
      let normalAirlines = [];
      let prefCarrierExtraCall = [];
      if (mergedSearchObj.prefcarrier !== 'All') {
        const hasPrefCarrier =
          SPECIAL_AIRLINES.indexOf(mergedSearchObj.prefcarrier) > -1;
        if (hasPrefCarrier) {
          normalAirlines = [mergedSearchObj.prefcarrier];
        } else {
          normalAirlines = [...SPECIAL_AIRLINES];
          setAlert({
            title: formattedMessage('flight_search_title'),
            variant: 'error',
            description: `${formattedMessage(
              'showing_results_of',
            )} 6E, SG, UK, I5, QP ${formattedMessage('with')} ${
              mergedSearchObj.searchtype
            } ${formattedMessage('fare_instead')} ${
              mergedSearchObj.prefcarrier
            }`,
          });
        }
      } else {
        normalAirlines = [...SPECIAL_AIRLINES];
        // prefCarrierExtraCall = ['6E'];
        if (
          mergedSearchObj.prefcarrier !== '6E' &&
          mergedSearchObj.prefcarrier !== 'All'
        ) {
          prefCarrierExtraCall = ['6E'];
        }
      }
      const airlinesLength =
        prefCarrierExtraCall.length + normalAirlines.length;
      normalAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });

      prefCarrierExtraCall.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    }
  };

  const getFlightSearchResults = async (mergedSearchObj, controller) => {
    if (
      mergedSearchObj.searchtype === 'seniorcitizen' ||
      mergedSearchObj.searchtype === 'student'
    ) {
      if (
        parseInt(mergedSearchObj.numinfants, 10) > 0 ||
        parseInt(mergedSearchObj.numchildren, 10) > 0
      ) {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }
    sendParallelRequests(mergedSearchObj, controller);
  };
  const resetSearchResults = () => {
    setHasSearchResults(undefined);
    setProgressWidth(0);
    onwardAllSearchResultsRef.current = [];
    returnAllSearchResultsRef.current = [];
    setPage(0);
    setMinFlightFare(0);
    setMaxFlightFare(0);
    setSelectedFilters({
      selectedMinPrice: 0,
      selectedMaxPrice: 0,
      selectedOnwardStops: [],
      selectedReturnStops: [],
      selectedOnwardDepartureTimes: [],
      selectedReturnDepartureTimes: [],
      selectedOnwardArraivalTimes: [],
      selectedReturnArraivalTimes: [],
      selectedOnwardCarriers: [],
      selectedReturnCarriers: [],
      selectedFareTypes: [],
      selectedRefundStatus: [],
      selectedFlightNumber: '',
      selectedEquipment: '',
      isOnwardSameDayArraival: false,
      isReturnSameDayArraival: false,
    });
    sectorInfoRef.current = '';
    flightCarriesRef.current = [];
    setSelectedOnwardFare(undefined);
    setSelectedReturnFare(undefined);
    roundTripSectorsRef.current = [];
    flightFaresRef.current = [];
    showProgressRef.current = true;
    setSelectedOnwardForEmail([]);
    setSelectedReturnForEmail([]);
    setselectedClassInfo({
      onwardFlight: undefined,
      returnFlight: undefined,
      selectedOnwardClassFare: undefined,
      selectedReturnClassFare: undefined,
      cacheKey: '',
      cacheKey_return: '',
      selectedOnwardList: [],
      selectedReturnList: [],
    });
    passThroughResponseRef.current = null;
    onwardFlightCarriesRef.current = [];
    returnFlightCarriesRef.current = [];
    setFifteenMinFromNowInMilli(
      getNewDate(TODAY_DATE).getTime() + FIFTEEN_MIN_IN_MILLI_SECS,
    );
  };

  useEffect(() => {
    setAbortController(new AbortController());
    if (searchParams) {
      const currentParams = Object.fromEntries([...searchParams]);
      setSearchRequest(currentParams);
      const searchObj = {
        origin: '',
        destination: '',
        onwarddate: getNewDate(TODAY_DATE),
        returndate: '',
        numadults: '1',
        numchildren: '0',
        numinfants: '0',
        journeytype: 'OneWay',
        prefclass: 'Y',
        requestformat: 'JSON',
        resultformat: 'JSON',
        searchtype: 'normal',
        sortkey: '',
        issbt: 'false',
        profileid: '',
        numresults: 100,
        actionname: 'FLIGHTSEARCH',
        preddeptimewindow: null,
        prefarrtimewindow: null,
        prefcarrier: '',
        prefcarrierall: '',
        excludecarriers: '',
        refundtype: 'All',
        layovertime: '',
        promocode: '',
      };
      const mergedSearchObj = { ...searchObj, ...currentParams };
      resetSearchResults();
      roundTripSectorsRef.current.push(
        `${currentParams.origin}-${currentParams.destination}`,
      );
      roundTripSectorsRef.current.push(
        `${currentParams.destination}-${currentParams.origin}`,
      );
      sectorInfoRef.current = `${currentParams.origin}-${currentParams.destination}`;
      setSelectedSector(roundTripSectorsRef.current[0]);
      if (mergedSearchObj.nonstopsearch === 'true') {
        setSelectedFilters((prev) => ({
          ...prev,
          selectedOnwardStops: ['0'],
          selectedReturnStops: ['0'],
        }));
      }
      const controller = abortController;
      const { signal } = controller;
      getFlightSearchResults(mergedSearchObj, signal);
    }
    return () => {
      if (abortController) {
        abortController.abort(); // Clean up controller on component unmount or query change
      }
    };
  }, [searchParams]);

  const handleOnwardFareSelection = (flight, fare) => {
    setselectedClassInfo((prev) => ({
      ...prev,
      onwardFlight: flight,
      selectedOnwardClassFare: undefined,
      cacheKey: fare.nextraflightkey,
      selectedOnwardList: [],
    }));
    setSelectedOnwardFare(fare);
    setSelectedOnWardFlight(flight);
    if (selectedReturnFare === undefined) {
      setSelectedSector(roundTripSectorsRef.current[1]);
    }
  };

  const handleReturnFareSelection = (flight, fare) => {
    setselectedClassInfo((prev) => ({
      ...prev,
      returnFlight: flight,
      cacheKey_return: fare.nextraflightkey,
      selectedReturnClassFare: undefined,
      selectedReturnList: [],
    }));
    setSelectedReturnFare(fare);
    setSelectedReturnFlight(flight);
    if (selectedOnwardFare === undefined) {
      setSelectedSector(roundTripSectorsRef.current[0]);
    }
  };

  const navigateToBookingPage = (rePriceResponse) => {
    const flights = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0],
      return:
        rePriceResponse.flightjourneys[1].flightoptions[0].recommendedflight[0],
    };
    const fares = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0]
          .flightfare,
      return:
        rePriceResponse.flightjourneys[1].flightoptions[0].recommendedflight[0]
          .flightfare,
    };
    const fareKeys = {
      onward: selectedOnwardFare.nextraflightkey,
      return: selectedReturnFare.nextraflightkey,
    };
    navigate(NAVIGATION_ROUTES.FLIGHT.FLIGHT_BOOK_ROUTE, {
      state: {
        searchRequest,
        rePriceResponse,
        selectedFlight: flights,
        selectedFare: fares,
        selectedFareKeys: fareKeys,
        passThroughInfo: passThroughResponseRef.current,
        journeyType: 'roundtrip',
        domInt: 'international',
      },
    });
  };

  const handlegetClassFare = async () => {
    const list = [
      ...selectedClassInfo.selectedOnwardList,
      ...selectedClassInfo.selectedReturnList,
    ];
    setIsLoading(true);
    const response = await getClassAvailabilityFareForRoundtrip(
      selectedClassInfo.cacheKey,
      selectedClassInfo.cacheKey_return,
      'international',
      list,
    );
    if (
      response &&
      response.NextraPricingResponseV4 &&
      response.NextraPricingResponseV4.statuscode === '200'
    ) {
      const res = await getPassThroughInfo(
        'international',
        response.NextraPricingResponseV4.bookingkey,
      );
      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        const { PassthroughBookingObject } = res.ApiStatus.Result;
        if (PassthroughBookingObject) {
          passThroughResponseRef.current = PassthroughBookingObject;
        }
      }
      const onwardRePrice =
        response.NextraPricingResponseV4.flightjourneys[0].flightoptions[0]
          .recommendedflight[0].flightfare.totalfq;
      const returnRePrice =
        response.NextraPricingResponseV4.flightjourneys[1].flightoptions[0]
          .recommendedflight[0].flightfare.totalfq;
      let onwardPrice = selectedOnwardFare.totalfq;
      let returnPrice = selectedReturnFare.totalfq;
      if (selectedClassInfo.selectedOnwardClassFare) {
        onwardPrice = selectedClassInfo.selectedOnwardClassFare.totalfq;
      }
      if (selectedClassInfo.selectedReturnClassFare) {
        returnPrice = selectedClassInfo.selectedReturnClassFare.totalfq;
      }
      if (onwardPrice + returnPrice !== onwardRePrice + returnRePrice) {
        bookingResponseRef.current = response.NextraPricingResponseV4;
        setnewRepricedAmount(onwardRePrice + returnRePrice);
        setOldAmount(onwardPrice + returnPrice);
        setShowPriceChangedModal(true);
      } else {
        navigateToBookingPage(response.NextraPricingResponseV4);
      }
    }
    setIsLoading(false);
  };

  const continueBooking = async () => {
    setOpenAlerDialog(false);
    if (
      selectedClassInfo.selectedOnwardList.length > 0 ||
      selectedClassInfo.selectedReturnList.length > 0
    ) {
      handlegetClassFare();
      return;
    }
    setIsLoading(true);
    try {
      const userProifle = getObjectFromLS(APP_USER_PROFILE);
      const response = await validateIntlNormalRtFlightPriceApi(
        userProifle.agentId,
        searchRequest.journeytype,
        selectedOnwardFare.nextraflightkey,
        selectedReturnFare.nextraflightkey,
      );
      if (response && response.NextraPricingResponseV4?.statuscode === '200') {
        const res = await getPassThroughInfo(
          'international',
          response.NextraPricingResponseV4.bookingkey,
        );
        if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
          const { PassthroughBookingObject } = res.ApiStatus.Result;
          if (PassthroughBookingObject) {
            passThroughResponseRef.current = PassthroughBookingObject;
          }
        }
        if (response.NextraPricingResponseV4.pricechanged) {
          bookingResponseRef.current = response.NextraPricingResponseV4;
          setnewRepricedAmount(response.NextraPricingResponseV4.newamount);
          setOldAmount(response.NextraPricingResponseV4.oldamount);
          setShowPriceChangedModal(true);
        } else {
          navigateToBookingPage(response.NextraPricingResponseV4);
        }
      } else {
        setAlert({
          title: formattedMessage('booking_error'),
          description: response?.ApiStatus?.Message || 'Error',
          variant: 'error',
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleBook = async () => {
    try {
      const searchRequestOnwardOrigin = searchRequest.origin;
      const searchRequestOnwardDestination = searchRequest.destination;
      const selectedFlightOnwardOrigin =
        selectedOnwardFlight.flightlegs[0].origin;
      const selectedFlightOnwardDestination =
        selectedOnwardFlight.flightlegs[
          selectedOnwardFlight.flightlegs.length - 1
        ].destination;
      const searchRequestReturnOrigin = searchRequest.destination;
      const searchRequestReturnDestination = searchRequest.origin;
      const selectedFlightReturnOrigin =
        selectedReturnFlight.flightlegs[0].origin;
      const selectedFlightRetuenDestination =
        selectedReturnFlight.flightlegs[
          selectedReturnFlight.flightlegs.length - 1
        ].destination;

      if (
        searchRequestOnwardOrigin !== selectedFlightOnwardOrigin ||
        searchRequestOnwardDestination !== selectedFlightOnwardDestination
      ) {
        alertMessageRef.current = `You Onward Searched flights from ${searchRequestOnwardOrigin} to ${searchRequestOnwardDestination} but booking from ${selectedFlightOnwardOrigin} to ${selectedFlightOnwardDestination}. Do you want to continue with it?`;
        setOpenAlerDialog(true);
      } else if (
        searchRequestReturnOrigin !== selectedFlightReturnOrigin ||
        searchRequestReturnDestination !== selectedFlightRetuenDestination
      ) {
        alertMessageRef.current = `You Return Searched flights from ${searchRequestReturnOrigin} to ${searchRequestReturnDestination} but booking from ${selectedFlightReturnOrigin} to ${selectedFlightRetuenDestination}. Do you want to continue with it?`;
        setOpenAlerDialog(true);
      } else {
        continueBooking();
      }
    } catch (error) {
      //
    }
  };
  const handlePriceChangedModalClose = (isContinue) => {
    if (isContinue) {
      navigateToBookingPage(bookingResponseRef.current);
    }
    setShowPriceChangedModal(false);
  };

  const handleOnwardPrevDay = async () => {
    if (searchRequest && searchRequest.onwarddate) {
      const request = { ...searchRequest };
      const todayDate = getNewDate(TODAY_DATE);
      const date = sub(getNewDate(searchRequest.onwarddate), { days: 1 });
      if (isBeforeDate(todayDate, date) || isSameDate(todayDate, date)) {
        request.onwarddate = formatDate(getNewDate(date), API_DATE_FORMAT);
        resetSearchResults();
        let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${request.onwarddate}&returndate=${searchRequest.returndate}`;
        queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
        );
      } else {
        setAlert({
          variant: 'error',
          title: 'Flight Search',
          description: 'Cannot search for Yesterday',
        });
      }
    }
  };

  const handleOnwardNextDay = async () => {
    if (searchRequest && searchRequest.onwarddate) {
      const request = { ...searchRequest };
      const returnDate = getNewDate(request.returndate);
      const date = add(getNewDate(searchRequest.onwarddate), { days: 1 });
      if (isAfterDate(returnDate, date) || isSameDate(returnDate, date)) {
        request.onwarddate = formatDate(getNewDate(date), API_DATE_FORMAT);
        resetSearchResults();
        let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${request.onwarddate}&returndate=${searchRequest.returndate}`;
        queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
        );
      } else {
        setAlert({
          variant: 'error',
          title: 'Flight Search',
          description: 'Onward Date should not be grater than return date',
        });
      }
    }
  };

  const handleReturnPrevDay = () => {
    if (searchRequest && searchRequest.returndate) {
      const request = { ...searchRequest };
      const onwardDate = getNewDate(request.onwarddate);
      const date = sub(getNewDate(searchRequest.returndate), { days: 1 });
      if (isBeforeDate(onwardDate, date) || isSameDate(onwardDate, date)) {
        request.returndate = formatDate(getNewDate(date), API_DATE_FORMAT);
        resetSearchResults();
        let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${searchRequest.onwarddate}&returndate=${request.returndate}`;
        queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
        );
      } else {
        setAlert({
          variant: 'error',
          title: 'Flight Search',
          description: 'Return date cannot be less than onward date',
        });
      }
    }
  };

  const handleReturnNextDay = () => {
    if (searchRequest && searchRequest.returndate) {
      const request = { ...searchRequest };
      const date = add(getNewDate(searchRequest.returndate), { days: 1 });
      request.returndate = formatDate(getNewDate(date), API_DATE_FORMAT);
      resetSearchResults();
      let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${searchRequest.onwarddate}&returndate=${request.returndate}`;
      queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    }
  };

  const handleOnwardSelectionForEmail = (flight, fare) => {
    setSelectedOnwardForEmail((prevItems) => {
      if (
        prevItems.some(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey === fare.nextraflightkey,
        )
      ) {
        return prevItems.filter(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey !== fare.nextraflightkey,
        );
      }
      return [...prevItems, { flight, fare }];
    });
  };

  const handleReturnSelectionForEmail = (flight, fare) => {
    setSelectedReturnForEmail((prevItems) => {
      if (
        prevItems.some(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey === fare.nextraflightkey,
        )
      ) {
        return prevItems.filter(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey !== fare.nextraflightkey,
        );
      }
      return [...prevItems, { flight, fare }];
    });
  };

  const handleopenWhatsappModal = () => {
    if (
      selectedOnwardForEmail.length > 0 &&
      selectedReturnForEmail.length > 0
    ) {
      setOpenWhatsappModal(true);
    } else {
      setAlert({
        title: 'WhatsApp Flight Options',
        description: 'Select atleast one onward and return fare',
        variant: 'error',
      });
    }
  };

  const handleOpenEmailModal = () => {
    if (
      selectedOnwardForEmail.length > 0 &&
      selectedReturnForEmail.length > 0
    ) {
      setOpenEmailModal(true);
    } else {
      setAlert({
        title: 'Email Flight Options',
        description: 'Select atleast one onward and return fare',
        variant: 'error',
      });
    }
  };

  const handleSendWhatsappMessage = (msg, whatsappNumber) => {
    setIsLoading(true);
    const encodedMessage = encodeURIComponent(msg);
    const whatsAppUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsAppUrl, '_blank');
    setOpenWhatsappModal(false);
    setSelectedOnwardForEmail([]);
    setSelectedReturnForEmail([]);
    setIsLoading(false);
  };

  const handleSendEmailMessage = async (emailDetails, emailContent) => {
    setIsLoading(true);
    let fromEmail = '';
    let fromName = '';
    const res = await getUserDetails(agentid);
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      fromName = `${User.FirstName} ${User.LastName}`;
    }
    if (fromEmail !== '') {
      const emailSub = `Your flight booking details for ${
        searchRequest.originLocation.split(',')[0]
      } - 
      ${searchRequest.destinationLocation.split(',')[0]} ${formatDate(
        getNewDate(searchRequest.onwarddate),
        API_DATE_FORMAT,
      )} | ${formatDate(
        getNewDate(searchRequest.returndate),
        API_DATE_FORMAT,
      )}`;
      const response = await emailFlightOptions(
        fromEmail,
        fromName,
        emailDetails,
        emailContent,
        emailSub,
      );
      if (response && response.Root?.Status === 'OK') {
        setAlert({
          title: formattedMessage('email_btn'),
          description: formattedMessage('email_sent_successfully'),
          variant: 'success',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      } else {
        setAlert({
          title: formattedMessage('email_btn'),
          description: response.Root?.Message
            ? response.Root?.Message
            : formattedMessage('failed_send_email'),
          variant: 'error ',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      }
    } else {
      setAlert({
        title: formattedMessage('user_Details'),
        description: res.ApiStatus?.Message
          ? res.ApiStatus?.Message
          : formattedMessage('failed_toload_agent_Details'),
        variant: 'error ',
      });
      setOpenEmailModal(false);
      setIsLoading(false);
    }
    setSelectedOnwardForEmail([]);
    setSelectedReturnForEmail([]);
  };

  const handleTimeFormatChange = (isAmPmFormat) => {
    setIsAmPmFormatSelected(isAmPmFormat);
  };

  const handleClassSelectForRoundtrip = (
    flight,
    fare,
    classFare,
    list,
    isonward,
  ) => {
    if (isonward) {
      setselectedClassInfo((prev) => ({
        ...prev,
        onwardFlight: flight,
        selectedOnwardClassFare: classFare,
        cacheKey: fare.nextraflightkey,
        selectedOnwardList: list,
      }));
      setSelectedOnwardFare(fare);
      setSelectedOnWardFlight(flight);
      if (selectedReturnFare === undefined) {
        setSelectedSector(roundTripSectorsRef.current[1]);
      }
    } else {
      setselectedClassInfo((prev) => ({
        ...prev,
        returnFlight: flight,
        selectedReturnClassFare: classFare,
        cacheKey_return: fare.nextraflightkey,
        selectedReturnList: list,
      }));
      setSelectedReturnFare(fare);
      setSelectedReturnFlight(flight);
      if (selectedOnwardFare === undefined) {
        setSelectedSector(roundTripSectorsRef.current[0]);
      }
    }
  };
  const handleFareInclusion = async (domInt) => {
    const response = await getFareInclusion(domInt);
    if (
      response &&
      response.Root &&
      response.Root.Status === 'OK' &&
      response.Root.StatusCode === 200
    ) {
      const fareInclusionsMap = {};
      let fareInclusions = response.Root.Result.FareInclusions.FareInclusion;
      fareInclusions = Array.isArray(fareInclusions)
        ? fareInclusions
        : [fareInclusions];
      fareInclusions.forEach((incl, index) => {
        if (fareInclusionsMap[incl.FareType]) {
          fareInclusionsMap[incl.FareType] = incl;
        } else {
          fareInclusionsMap[incl.FareType] = incl;
        }
      });
      fareInclusionRef.current = fareInclusionsMap;
    }
  };

  useEffect(() => {
    const domInt = searchParams.get('domInt');
    handleFareInclusion(domInt);
  }, []);
  return (
    <section className="flight-round-trip-search-results-page">
      {showProgressRef.current && (
        <div className="flight-progress-container">
          <ProgressBar striped variant="info" now={progressWidth} />
        </div>
      )}
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <div className="countdown-timer-container visually-hidden">
        <CountdownTimer
          targetDate={fifteenMinFromNowInMilli}
          continueBtnText={formattedMessage('continue_btn')}
          continueRoutePath={formattedMessage('refresh_btn')}
        />
      </div>
      {searchRequest && (
        <>
          {!isMobileWidth() ? (
            <div className="modify-search-container" ref={flightModifyRef}>
              <ModifySearch
                isModifySearch={isModifySearch}
                previousSearchRequest={searchRequest}
              />
            </div>
          ) : (
            <div className="modify-search-container">
              <div className="d-flex">
                <AppIconButton
                  onClick={() => navigate(-1)}
                  className="white-color"
                  variant="transparent"
                >
                  <MdOutlineArrowBack />
                </AppIconButton>
                <div className="d-flex justify-content-between p-2 align-items-center flex-1">
                  <div className="fs-14 white-color">
                    {searchRequest.originLocation.split(',')[0]} to{' '}
                    {searchRequest.destinationLocation.split(',')[0]}
                    <div className="fs-10">
                      <span>{searchRequest.journeytype} | </span>
                      <span>
                        {formatDate(
                          getNewDate(searchRequest.onwarddate),
                          DATE_MONTH_VIEW_FORMAT,
                        )}{' '}
                        |{' '}
                      </span>
                      <span>
                        {formatDate(
                          getNewDate(searchRequest.returndate),
                          DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex  align-items-center">
                    {isModifySearch ? (
                      <AppIconButton
                        className="white-color"
                        variant="transparent"
                        onClick={() => setIsModifySearch(false)}
                      >
                        <MdClose className="fs-4" />
                      </AppIconButton>
                    ) : (
                      <AppIconButton
                        className="white-color"
                        variant="transparent"
                        onClick={() => setIsModifySearch(true)}
                      >
                        <MdOutlineCreate className="fs-4" />
                      </AppIconButton>
                    )}
                    <AppIconButton
                      variant="transparent"
                      className="fs-14 white-color"
                      onClick={() => setShowInvoiceFare((prev) => !prev)}
                    >
                      {showInvoiceFare ? (
                        <IoMdEyeOff title="Net Fare" />
                      ) : (
                        <IoMdEye title="Net Fare" />
                      )}
                    </AppIconButton>
                    <AppIconButton
                      className="white-color"
                      variant="transparent"
                      onClick={() => setOpenFilters(true)}
                    >
                      <MdOutlineFilterAlt className="fs-4" />
                    </AppIconButton>
                  </div>
                </div>
              </div>
              {isModifySearch && (
                <div className="slide-container">
                  <ModifySearch
                    isModifySearch={isModifySearch}
                    previousSearchRequest={searchRequest}
                  />
                </div>
              )}
            </div>
          )}
          {progressWidth < 100 &&
            onwardAllSearchResultsRef.current.length === 0 && (
              <AppPreviewLoader />
            )}
          {hasSearchResults ? (
            <section className="flight-app-container">
              <Row className="spacing-16">
                <Col lg={3} className=" display-md-none p-0 mt-0 ">
                  <FlightSelectionViewToggle />
                  <RoundTripFilters
                    minPrice={minFlightFare}
                    maxPrice={maxFlightFare}
                    // carriers={flightCarriesRef.current}
                    onwardCarriers={onwardFlightCarriesRef.current}
                    returnCarriers={returnFlightCarriesRef.current}
                    fareTypes={flightFaresRef.current}
                    selectedFilters={selectedFilters}
                    onApplyFilter={handleApplyFilter}
                    onTimeFormatChange={handleTimeFormatChange}
                    conversionRate={conversionRate}
                    currencyOption={currencyOption}
                    sectorInfo={sectorInfoRef.current}
                  />
                </Col>
                <Col lg={9} className="mt-0 margin-for-hotel-results-card">
                  <div className="hide-in-mobile">
                    <div className="d-flex justify-content-between align-items-center hide-in-mobile">
                      <span className="fs-5 fw-500">
                        {selectedSector === roundTripSectorsRef.current[0]
                          ? `Flights From ${
                              searchRequest.originLocation.split(',')[0]
                            } 
                      to ${searchRequest.destinationLocation.split(',')[0]}`
                          : `Flights From ${
                              searchRequest.destinationLocation.split(',')[0]
                            } 
                      to ${searchRequest.originLocation.split(',')[0]}`}
                      </span>
                      <div>
                        <AppIconButton
                          variant="transparent"
                          className="fs-14"
                          onClick={handleopenWhatsappModal}
                        >
                          <MdOutlineWhatsapp title="WhatsApp" />
                        </AppIconButton>
                        <AppIconButton
                          variant="transparent"
                          className="fs-14"
                          onClick={handleOpenEmailModal}
                        >
                          <MdOutlineMail title="Email" />
                        </AppIconButton>
                        <AppIconButton
                          variant="transparent"
                          className="fs-14"
                          onClick={() => setShowInvoiceFare((prev) => !prev)}
                        >
                          {showInvoiceFare ? (
                            <IoMdEyeOff title="Net Fare" />
                          ) : (
                            <IoMdEye title="Net Fare" />
                          )}
                        </AppIconButton>
                      </div>
                    </div>
                    <section className="flight-sort-options d-flex">
                      <div
                        onClick={() =>
                          setSelectedSector(roundTripSectorsRef.current[0])
                        }
                        className={`sort-btn ${
                          selectedSector === roundTripSectorsRef.current[0]
                            ? 'selected-sort-btn'
                            : ''
                        }`}
                      >
                        <div>
                          {`${searchRequest.originLocation.split(',')[0]} -
                          ${searchRequest.destinationLocation.split(',')[0]}`}
                        </div>
                        <div>
                          {formatDate(
                            getNewDate(searchRequest.onwarddate),
                            DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </div>
                      </div>
                      <div
                        onClick={() =>
                          setSelectedSector(roundTripSectorsRef.current[1])
                        }
                        className={`sort-btn ${
                          selectedSector === roundTripSectorsRef.current[1]
                            ? 'selected-sort-btn'
                            : ''
                        }`}
                      >
                        <div>
                          {`${searchRequest.destinationLocation.split(',')[0]} -
                          ${searchRequest.originLocation.split(',')[0]}`}
                        </div>
                        <div>
                          {formatDate(
                            getNewDate(searchRequest.returndate),
                            DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </div>
                      </div>
                    </section>
                    {selectedSector === roundTripSectorsRef.current[0] && (
                      <div className="my-2">
                        <div className="flight-sort-options d-flex">
                          <div
                            className={`sort-btn ${
                              onwardSortParamRef.current === 'price'
                                ? 'selected-sort-btn'
                                : ''
                            }`}
                            onClick={() => handleSort('price', 'asc', true)}
                          >
                            Cheapest Flights
                          </div>
                          <div
                            className={`sort-btn border-inline ${
                              onwardSortParamRef.current === 'duration'
                                ? 'selected-sort-btn'
                                : ''
                            }`}
                            onClick={() => handleSort('duration', 'asc', true)}
                          >
                            Shortest Duration
                          </div>
                          <div
                            className={`sort-btn ${
                              onwardSortParamRef.current === 'departure'
                                ? 'selected-sort-btn'
                                : ''
                            }`}
                            onClick={() => handleSort('departure', 'asc', true)}
                          >
                            Early Depart
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedSector === roundTripSectorsRef.current[1] && (
                      <div className="my-2">
                        <div className="flight-sort-options d-flex">
                          <div
                            className={`sort-btn ${
                              returnSortParamRef.current === 'price'
                                ? 'selected-sort-btn'
                                : ''
                            }`}
                            onClick={() => handleSort('price', 'asc')}
                          >
                            Cheapest Flights
                          </div>
                          <div
                            className={`sort-btn border-inline ${
                              returnSortParamRef.current === 'duration'
                                ? 'selected-sort-btn'
                                : ''
                            }`}
                            onClick={() => handleSort('duration', 'asc')}
                          >
                            Shortest Duration
                          </div>
                          <div
                            className={`sort-btn ${
                              returnSortParamRef.current === 'departure'
                                ? 'selected-sort-btn'
                                : ''
                            }`}
                            onClick={() => handleSort('departure', 'asc')}
                          >
                            Early Depart
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {isMobileWidth() && (
                    <section className="flight-sort-options d-flex pt-2">
                      <div
                        onClick={() =>
                          setSelectedSector(roundTripSectorsRef.current[0])
                        }
                        className={`sort-btn ${
                          selectedSector === roundTripSectorsRef.current[0]
                            ? 'selected-sort-btn'
                            : ''
                        }`}
                      >
                        <div>
                          {`${searchRequest.originLocation.split(',')[0]} -
                          ${searchRequest.destinationLocation.split(',')[0]}`}
                        </div>
                        <div>
                          {formatDate(
                            getNewDate(searchRequest.onwarddate),
                            DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </div>
                      </div>
                      <div
                        onClick={() =>
                          setSelectedSector(roundTripSectorsRef.current[1])
                        }
                        className={`sort-btn ${
                          selectedSector === roundTripSectorsRef.current[1]
                            ? 'selected-sort-btn'
                            : ''
                        }`}
                      >
                        <div>
                          {`${searchRequest.destinationLocation.split(',')[0]} -
                          ${searchRequest.originLocation.split(',')[0]}`}
                        </div>
                        <div>
                          {formatDate(
                            getNewDate(searchRequest.returndate),
                            DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </div>
                      </div>
                    </section>
                  )}
                  <section className=" pt-2">
                    {selectedSector === roundTripSectorsRef.current[0] && (
                      <div className="flex-1 rt-info">
                        {isMobileWidth() && (
                          <SortOptions
                            onSort={handleSort}
                            isOnward
                            prevSortParam={onwardSortParamRef.current}
                          />
                        )}
                        {shownOnwardResults.map((row, index) => (
                          <OneWayResultCard
                            name="one_way_card"
                            domint="international"
                            key={row.recommendedflight[0].nextraflightkey}
                            flight={row.recommendedflight[0]}
                            selectedFlight={selectedOnwardFlight}
                            onFareSelection={handleOnwardFareSelection}
                            journeyType={searchRequest.journeytype}
                            searchRequest={searchRequest}
                            selectedFare={selectedOnwardFare}
                            showInvoiceFare={showInvoiceFare}
                            onSelectForEmail={handleOnwardSelectionForEmail}
                            flightsForEmail={selectedOnwardForEmail}
                            index={index}
                            isAmPmFormat={isAmPmFormatSelected}
                            isOnward
                            conversionRate={conversionRate}
                            currencyOption={currencyOption}
                            onClassSelectForRoundtrip={
                              handleClassSelectForRoundtrip
                            }
                            onShareViaEmail={handleOpenEmailModal}
                            onShareViaWhatsapp={handleopenWhatsappModal}
                            fareInclusions={fareInclusionRef.current}
                          />
                        ))}
                        {onwardSearchResults.length === 0 && (
                          <NoSearchResults
                            title={formattedMessage(
                              'no_search_results_onward_title',
                            )}
                            message={formattedMessage(
                              'no_search_results_message_1',
                            )}
                          />
                        )}
                      </div>
                    )}
                    {selectedSector === roundTripSectorsRef.current[1] && (
                      <div className="flex-1 rt-info">
                        {isMobileWidth() && (
                          <SortOptions
                            isOnward={false}
                            onSort={handleSort}
                            prevSortParam={returnSortParamRef.current}
                          />
                        )}
                        {shownReturnResults.map((row, index) => (
                          <OneWayResultCard
                            name="return_card"
                            domint="international"
                            key={row.recommendedflight[0].nextraflightkey}
                            flight={row.recommendedflight[0]}
                            selectedFlight={selectedReturnFlight}
                            onFareSelection={handleReturnFareSelection}
                            journeyType={searchRequest.journeytype}
                            searchRequest={searchRequest}
                            selectedFare={selectedReturnFare}
                            showInvoiceFare={showInvoiceFare}
                            onSelectForEmail={handleReturnSelectionForEmail}
                            flightsForEmail={selectedReturnForEmail}
                            index={index}
                            isOnward={false}
                            isAmPmFormat={isAmPmFormatSelected}
                            conversionRate={conversionRate}
                            currencyOption={currencyOption}
                            onClassSelectForRoundtrip={
                              handleClassSelectForRoundtrip
                            }
                            onShareViaEmail={handleOpenEmailModal}
                            onShareViaWhatsapp={handleopenWhatsappModal}
                            fareInclusions={fareInclusionRef.current}
                          />
                        ))}
                        {returnSearchResults.length === 0 && (
                          <NoSearchResults
                            title={formattedMessage(
                              'no_search_results_return_title',
                            )}
                            message={formattedMessage(
                              'no_search_results_message_1',
                            )}
                          />
                        )}
                      </div>
                    )}
                  </section>
                </Col>
              </Row>
            </section>
          ) : (
            hasSearchResults === undefined &&
            progressWidth === 100 && <NoSearchResults />
          )}
        </>
      )}
      {(selectedOnwardFare || selectedReturnFare) && (
        <ResultsFooter
          journeyType="roundtrip"
          selectedFare={{
            onward: selectedOnwardFare,
            return: selectedReturnFare,
          }}
          selectedClassInfo={selectedClassInfo}
          selectedFlight={{
            onward: selectedOnwardFlight,
            return: selectedReturnFlight,
          }}
          searchRequest={searchRequest}
          onBook={handleBook}
          conversionRate={conversionRate}
          currencyOption={currencyOption}
          showInvoiceFare={showInvoiceFare}
        />
      )}
      {openFilters && (
        <AppSidebar
          sidebarTitle={formattedMessage('filters')}
          showActions
          onHideSidebar={() => setOpenFilters(false)}
          className=" position-relative p-0"
        >
          <FlightSelectionViewToggle />
          <RoundTripFilters
            minPrice={minFlightFare}
            maxPrice={maxFlightFare}
            // carriers={flightCarriesRef.current}
            onwardCarriers={onwardFlightCarriesRef.current}
            returnCarriers={returnFlightCarriesRef.current}
            fareTypes={flightFaresRef.current}
            selectedFilters={selectedFilters}
            onApplyFilter={handleApplyFilter}
            onTimeFormatChange={handleTimeFormatChange}
            conversionRate={conversionRate}
            currencyOption={currencyOption}
            isAmPmFormat={isAmPmFormatSelected}
            sectorInfo={sectorInfoRef.current}
          />
        </AppSidebar>
      )}
      {showPriceChangedModal && (
        <AppModal
          modalTitle="Fare Change Alert"
          showCloseButton={false}
          okText="Continue"
          cancelText="Select Another Flight"
          showFooter
          onModalClose={handlePriceChangedModalClose}
        >
          <div className="d-flex flex-column align-items-center red-color fs-3">
            <BsGraphUpArrow />
            <span>Ooops!</span>
          </div>
          <p className="fs-14 mb-0 text-center mt-2">
            The Airline has increased the fare on this route by{' '}
            {formatCurrency(newRepricedAmount - oldAmount)}
          </p>
          <p className="fs-14 mb-0 text-center">
            Please note that airfares e dynamicnd subject to change.
          </p>
          <p className="fs-14 mb-0 text-center">
            Select from the options below
          </p>
          <div className="d-flex flex-column align-items-center fw-600 fs-14 mt-3">
            <span>
              UPDATED FARE{'      '} {formatCurrency(newRepricedAmount)}
            </span>
            <span>
              ORIGINAL FARE{'      '} {formatCurrency(oldAmount)}
            </span>
            <span>
              DIFFERENCE FARE{'      '}{' '}
              {formatCurrency(newRepricedAmount - oldAmount)}
            </span>
          </div>
        </AppModal>
      )}
      {openEmailModal && (
        <AppModal
          modalTitle={formattedMessage('send_email_btn')}
          showCloseButton
          size="lg"
          onModalClose={() => setOpenEmailModal(false)}
        >
          <EmailContent
            selectedFlights={selectedOnwardForEmail}
            selectedRetunFlights={selectedReturnForEmail}
            onSend={handleSendEmailMessage}
            isRoundtrip
            searchRequest={searchRequest}
          />
        </AppModal>
      )}
      {openWhatsappModal && (
        <AppModal
          modalTitle="Send WhatsApp"
          showCloseButton
          size="lg"
          onModalClose={() => setOpenWhatsappModal(false)}
        >
          <RoundTripWhatsappModal
            onSend={handleSendWhatsappMessage}
            searchRequest={searchRequest}
            selectedOnwardFlights={selectedOnwardForEmail}
            selectedReturnFlights={selectedReturnForEmail}
          />
        </AppModal>
      )}
      {OpenAlerDialog && (
        <AppModal
          modalTitle="Are You Sure?"
          showCloseButton
          className="help-support-modal"
          cancelText="Close"
          onModalClose={() => setOpenAlerDialog(false)}
        >
          <div className="fs-16 align-items-center p-4">
            {alertMessageRef.current}
          </div>
          <div className="d-flex justify-content-end gap-3 p-2">
            <AppButton
              btnText="NO, Cancel"
              variant="outlined"
              onClick={() => setOpenAlerDialog(false)}
            />
            <AppButton btnText="Yes, Continue" onClick={continueBooking} />
          </div>
        </AppModal>
      )}
    </section>
  );
}

export default FlightRoundTripSearchResultsPagespl;
